/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Tab_PublishedInputs */

const en_admin_posts_tab_published = /** @type {(inputs: Admin_Posts_Tab_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Admin_Posts_Tab_PublishedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_tab_published = /** @type {((inputs?: Admin_Posts_Tab_PublishedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Tab_PublishedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_tab_published(inputs)
});
export { admin_posts_tab_published as "admin.posts.tab_published" }